<template>
  <div>
    <el-row
      type="flex"
      justify="space-between"
      class="mb-4"
    >
      <el-col :span="12">
        <div class="custom-label">Programaciones activas</div>
      </el-col>
      <el-col
        :span="12"
        style="text-align: right"
      >
        <el-button
          type="primary"
          size="default"
          @click="openDialog()"
        >
          + Nueva programación
        </el-button>
      </el-col>
    </el-row>

    <el-table
      :data="programacionList"
      border
      stripe
    >
      <el-table-column
        prop="Nombre"
        label="Nombre"
        min-width="150"
      />
      <el-table-column
        label="Intervalo"
        align="center"
        width="120"
      >
        <template #default="{ row }"> {{ row.IntervaloMinutos }} min </template>
      </el-table-column>
      <el-table-column
        label="Última ejecución"
        min-width="200"
      >
        <template #default="{ row }">
          <div v-if="row.UltimaEjecucion">
            {{ formatDate(row.UltimaEjecucion) }}<br />
            <small :style="{ color: row.UltimoResultado?.includes('Error') ? 'red' : 'green' }">
              {{ row.UltimoResultado }}
            </small>
          </div>
          <span v-else>Nunca</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Estado"
        align="center"
        width="100"
      >
        <template #default="{ row }">
          <el-tag :type="row.Activo ? 'success' : 'info'">
            {{ row.Activo ? 'Activo' : 'Inactivo' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column
        label="Acciones"
        align="center"
        width="180"
      >
        <template #default="{ row }">
          <el-button
            size="small"
            type="primary"
            title="Ejecutar ahora"
            :icon="IconPlay"
            @click="ejecutarJob(row)"
          ></el-button>
          <el-button
            size="small"
            type="warning"
            :icon="IconEdit"
            @click="openDialog(row)"
          ></el-button>
          <el-popconfirm
            title="¿Eliminar esta programación?"
            @confirm="deleteJob(row)"
          >
            <template #reference>
              <el-button
                size="small"
                type="danger"
                :icon="IconDelete"
              ></el-button>
            </template>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog
      v-model="dialogVisible"
      :title="isEdit ? 'Editar programación' : 'Nueva programación'"
      width="600px"
      destroy-on-close
    >
      <el-form
        ref="formRef"
        :model="form"
        :rules="rules"
        label-position="top"
      >
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item
              label="Nombre"
              prop="Nombre"
            >
              <el-input
                v-model="form.Nombre"
                placeholder="Ej: Exportación Táctica"
              />
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item
              label="Tipo de programación"
              prop="TipoProgramacion"
            >
              <el-select
                v-model="form.TipoProgramacion"
                placeholder="Seleccione un tipo"
                style="width: 100%"
              >
                <el-option
                  v-for="tipo in tiposProgramacion"
                  :key="tipo.clave"
                  :label="tipo.nombre"
                  :value="tipo.clave"
                />
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              label="Intervalo (minutos)"
              prop="IntervaloMinutos"
            >
              <el-input-number
                ref="inputRef"
                v-model="form.IntervaloMinutos"
                :min="1"
                :formatter="formatter"
                :parser="parser"
                style="width: 100%"
                @focus="handleFocus"
                @blur="handleBlur(form.IntervaloMinutos)"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Estado">
              <el-switch
                v-model="form.Activo"
                active-text="Activado"
                inactive-text="Desactivado"
              />
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item
              label="Rango temporal (horas)"
              prop="RangoHoras"
            >
              <el-input-number
                ref="inputRef"
                v-model="form.RangoHoras"
                :min="1"
                :formatter="formatter"
                :parser="parser"
                style="width: 100%"
                @focus="handleFocus"
                @blur="handleBlur(form.RangoHoras)"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="Buffer de seguridad (min)"
              prop="BufferMinutos"
            >
              <el-input-number
                ref="inputRef"
                v-model="form.BufferMinutos"
                :min="0"
                :formatter="formatter"
                :parser="parser"
                style="width: 100%"
                @focus="handleFocus"
                @blur="handleBlur(form.BufferMinutos)"
              />
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item
              label="Carpeta destino"
              prop="CarpetaDestino"
            >
              <el-input
                v-model="form.CarpetaDestino"
                placeholder="Ej: C:\Sispro\Integraciones\"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="Talonario destino"
              prop="TalonarioDestino"
            >
              <el-input
                v-model="form.TalonarioDestino"
                maxlength="30"
                show-word-limit
                placeholder="Ej: TACTICA_SISPRO"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              label="Nombre del archivo"
              prop="NombreArchivo"
            >
              <el-input
                v-model="form.NombreArchivo"
                placeholder="Ej: propuestas_aprobadas.xlsx"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button @click="dialogVisible = false">Cancelar</el-button>
          <el-button
            type="primary"
            @click="saveJob"
            >Guardar programación</el-button
          >
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script setup>
import {
  ref,
  onMounted,
  computed,
} from 'vue';
import { storeToRefs } from 'pinia';
import { useGeneracionArchivosStore } from '@/stores/generacion_archivos_store';
import { useMessageError } from '@/shared/composables/message_error.js';
import { useMessageSuccess } from '@/shared/composables/message_success.js';
import { useLoading } from '@/shared/composables/loading.js';
import IconDelete from '~icons/mdi/delete';
import IconEdit from '~icons/mdi/edit';
import IconPlay from '~icons/mdi/play';
import { useLocaleNumberInput } from '@/shared/composables/useLocaleNumberInput.js';

const { inputRef, formatter, parser, handleFocus, handleBlur } = useLocaleNumberInput(null);

const store = useGeneracionArchivosStore();
const { programacionList, tiposProgramacion } = storeToRefs(store);
const { getProgramacionesHTTP, saveProgramacionHTTP, deleteProgramacionHTTP, ejecutarAhoraHTTP } =
  store;

const dialogVisible = ref(false);
const formRef = ref(null);
const isEdit = computed(() => !!form.value.Codigo);

const form = ref({
  Codigo: null,
  Nombre: '',
  TipoProgramacion: '',
  IntervaloMinutos: 60,
  RangoHoras: 48,
  BufferMinutos: 10,
  CarpetaDestino: '',
  NombreArchivo: 'propuestas_aprobadas.xlsx',
  Activo: true,
  TalonarioDestino: 'TACTICA_SISPRO',
});

const rules = {
  Nombre: [{ required: true, message: 'El nombre es obligatorio', trigger: 'blur' }],
  TipoProgramacion: [{ required: true, message: 'Seleccione un tipo', trigger: 'change' }],
  CarpetaDestino: [{ required: true, message: 'La ruta destino es obligatoria', trigger: 'blur' }],
  NombreArchivo: [
    { required: true, message: 'El nombre de archivo es obligatorio', trigger: 'blur' },
  ],
  TalonarioDestino: [
    { required: true, message: 'El talonario es obligatorio', trigger: 'blur' },
    { max: 30, message: 'Máximo 30 caracteres', trigger: 'blur' },
  ],
};

onMounted(async () => {
  useLoading().openLoading();
  try {
    await getProgramacionesHTTP();
  } catch (error) {
    useMessageError().open('No se pudieron cargar las programaciones');
  } finally {
    useLoading().closeLoading();
  }
});

const openDialog = (row = null) => {
  if (row) {
    form.value = { ...row };
  } else {
    form.value = {
      Codigo: null,
      Nombre: '',
      TipoProgramacion: 'PropuestasSisproERP',
      IntervaloMinutos: 60,
      RangoHoras: 48,
      BufferMinutos: 10,
      CarpetaDestino: 'C:\\Sispro\\Integraciones\\',
      NombreArchivo: 'propuestas_aprobadas.xlsx',
      TalonarioDestino: 'TACTICA_SISPRO',
      Activo: true,
    };
  }
  dialogVisible.value = true;
};

const saveJob = async () => {
  await formRef.value.validate(async (valid) => {
    if (valid) {
      useLoading().openLoading();
      try {
        await saveProgramacionHTTP(form.value);
        useMessageSuccess().open('Programación guardada con éxito');
        dialogVisible.value = false;
      } catch (error) {
        useMessageError().open('Error al guardar la programación');
      } finally {
        useLoading().closeLoading();
      }
    }
  });
};

const deleteJob = async (row) => {
  useLoading().openLoading();
  try {
    await deleteProgramacionHTTP(row.Codigo);
    useMessageSuccess().open('Programación eliminada');
  } catch (error) {
    useMessageError().open('Error al eliminar la programación');
  } finally {
    useLoading().closeLoading();
  }
};

const ejecutarJob = async (row) => {
  useLoading().openLoading();
  try {
    await ejecutarAhoraHTTP(row.Codigo);
    useMessageSuccess().open('Ejecución iniciada correctamente');
  } catch (error) {
    useMessageError().open('Error al ejecutar la programación');
  } finally {
    useLoading().closeLoading();
  }
};

const formatDate = (dateString) => {
  if (!dateString) return '';
  const d = new Date(dateString);
  return d.toLocaleString();
};
</script>

<style scoped>
.custom-label {
  font-weight: 600;
  margin-bottom: 8px;
  color: #333;
  font-size: 1.1rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
</style>
